import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { generatePositions } from '../CallsheetUtils';
import i18n from '../../../i18n';
import styles from '../../../assets/stylesheets/CallsheetInlineStyles';
import { TYPE_PREP } from '../../../constants/booking';
import CallsheetTable from './CallsheetTable';
import CallsheetSpecialProjectRow from './CallsheetSpecialProjectRow';
import NumberOfSetDoubleBookRow from './NumberOfSetDoubleBookRow';

class StylingRoomSheet extends Component {
  getLocationContact = () => {
    const { info, locationContacts } = this.props;
    return info.gender === 'male'
                ? locationContacts[TYPE_PREP][0]
                : locationContacts[TYPE_PREP][1];
  }

  render() {
    const { info, name, renderForEmail, locationContacts } = this.props;

    const locationContact = locationContacts && locationContacts[TYPE_PREP] ? this.getLocationContact() : i18n.t('noData');

    return (
      <CallsheetTable
        name={name}
        callTime={info.callTime}
        wrapTime={info.wrapTime}
        locationContacts={locationContact}
        renderForEmail={renderForEmail}
      >
        <NumberOfSetDoubleBookRow info={info} />
        <tr>
          <th colSpan="2" style={styles.tableCell}>
            {i18n.t('booking:skuCount')}
          </th>
          <th colSpan="2" style={styles.tableCell}>
            {i18n.t('booking:gender')}
          </th>
        </tr>
        <tr>
          <td colSpan="2" style={styles.tableCell}>
            {`${info.rtwCount} ${i18n.t('location:rtw').toUpperCase()}`}
            <br />
            {`${info.mflCount} ${i18n.t('location:mfl').toUpperCase()}`}
            <br />
            {`${info.omaccCount} ${i18n.t('location:omacc').toUpperCase()}`}
            <br />
            {`${info.petsCount} ${i18n.t('location:pets').toUpperCase()}`}
            <br />
            {`${info.kidsCount} ${i18n.t('location:kids').toUpperCase()}`}
            <br />
            {`${info.homeTechActivityCount} ${i18n.t('location:homeTechActivityAbreviation').toUpperCase()}`}
            <br />
            {`${info.selfCareCount} ${i18n.t('location:selfCareAbreviation').toUpperCase()}`}
            <br />
          </td>
          <td colSpan="2" style={styles.tableCell}>
            {i18n.t(`booking:${info.gender}`)}
          </td>
        </tr>
        <CallsheetSpecialProjectRow
          specialProject={info.specialProject}
        />
        {generatePositions(info)}
      </CallsheetTable>
    );
  }
}

StylingRoomSheet.propTypes = {
  locationContacts: PropTypes.objectOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.array])
  ).isRequired,
  name: PropTypes.string.isRequired,
  info: PropTypes.shape({
    callTime: PropTypes.string.isRequired,
    wrapTime: PropTypes.string.isRequired,
    numberOfSet: PropTypes.string.isRequired,
    isDoubleStylist: PropTypes.bool.isRequired,
    rtwCount: PropTypes.number.isRequired,
    mflCount: PropTypes.number.isRequired,
    omaccCount: PropTypes.number.isRequired,
    petsCount: PropTypes.number.isRequired,
    kidsCount: PropTypes.number.isRequired,
    homeTechActivityCount: PropTypes.number.isRequired,
    selfCareCount: PropTypes.number.isRequired,
    gender: PropTypes.string.isRequired,
    specialProject: PropTypes.shape({
      name: PropTypes.string.isRequired,
      notes: PropTypes.string.isRequired
    }),
    positions: PropTypes.objectOf(
      PropTypes.shape({
        employees: PropTypes.arrayOf(
          PropTypes.shape({ email: PropTypes.string, name: PropTypes.string })
        )
      })
    )
  }).isRequired,
  renderForEmail: PropTypes.bool.isRequired
};

export default StylingRoomSheet;
